import { Table } from '@tanstack/table-core';
import styles from './SelectedProductsDrawer.module.scss';
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import { useEffect, useMemo, useState } from 'react';
import { RestS } from '../../../../rest/rest-service';
import { ProductCostsFilter } from '../../../../interfaces/interfaces';
import CircularLoader from '../../../../components/common/CircularLoader/CircularLoader';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';

type Props = {
    tableState: Table<any>,
    ipConfig: { [x: string]: string },
    closeDrawer: (e: any) => void,
    // selectedRows: any[],
    allFilterState: ProductCostsFilter,
    allProducts: any[],
    allProductsLoading: boolean,
    product?: any,
    allProductSelected: boolean,
}



const SelectedProductsDrawer = ({ tableState, ipConfig, closeDrawer, allFilterState, allProducts, allProductsLoading, allProductSelected }: Props) => {


    const productList = useMemo(() => {
        const allSelectedRows = tableState?.getState().rowSelection;
        console.log('allProducts', allProducts);
        const partnerOrder = {
            'Shopify': 1,
            'Amazon Seller Central': 2,
            'Amazon Vendor Central': 3,
            // 'Flipkart Seller': 4
        };
        const selectedRowCount = Object.keys(allSelectedRows).reduce((prev, curVal) => {
            if (allSelectedRows[curVal] == true) {
                prev.push(curVal);
            }
            return prev;
        }, []);

        // console.log('selectedRows state', selectedRowCount.length);

        // console.log('filteredFrom all products', filteredProductState);

        const selectedProducts = allProducts.filter((item, index) => {
            if (allSelectedRows[item.productId] == true) {
                return true;
            } else {
                return false;
            }
        }).sort((a, b) => {
            // Prioritize Shopify over Amazon Seller Central
            if (partnerOrder[a.integrationPartner] !== partnerOrder[b.integrationPartner]) {
                return partnerOrder[a.integrationPartner] - partnerOrder[b.integrationPartner];
            }

            // Sort by quantity (assuming descending order, switch the comparison for ascending)
            if (a.quantity !== b.quantity) {
                return b.quantity - a.quantity; // For descending order; use a.quantity - b.quantity for ascending
            }

            // Move products with no name or '-' name to the end
            const nameA = a.productName === '-' || a.productName === '' ? 'zzzzzzzz' : a.productName;
            const nameB = b.productName === '-' || b.productName === '' ? 'zzzzzzzz' : b.productName;

            // Alphabetical order of productName within the same integrationPartner
            return nameA.localeCompare(nameB);
        });
        return selectedProducts;
    }, [tableState?.getState().rowSelection])

    return (
        <div className={styles.drawerRootContainer}>
            <div className={styles.drawerHeader}>
                <div className={styles.headerTitle}>
                    Selected Products
                </div>
                <div>
                    <MeritoButton type='secondary-1' icon={<CloseIcon />} onlyIcon={true} onClick={(e) => closeDrawer(e)} />
                    {/* <button className={styles.headerBtn} onClick={(e) => closeDrawer(e)}>
                        <CloseIcon />
                    </button> */}
                </div>
            </div>
            <div className={styles.drawerBody}>
                {!tableState?.getIsAllRowsSelected() ?
                    <>
                        {productList.map((values, index) => {
                            // const values = item?.original;
                            return (
                                <ProductContainer product={values} ipConfig={ipConfig} />
                            )

                        })}
                    </>
                    : allProductsLoading ?
                        <div className={styles.loadingContainer}>
                            <CircularLoader
                            // backgroundColor={
                            //     feedFor === InsightFeedFor.goalsHub ? "white" : "#f0eff4"
                            // }
                            />
                        </div>
                        :
                        allProducts && allProducts.length > 0 ? productList.map((product, index) => {
                            return <ProductContainer product={product} ipConfig={ipConfig} />
                        }) : null
                }
            </div>
        </div>

    );
}

const ProductContainer = ({ ipConfig, product }) => {

    return (
        <div className={styles.productContainer}>
            {product?.integrationPartner ?
                <div className={styles.imageContainer}>
                    <img src={ipConfig[product?.integrationPartner]['logo']} alt="" />
                </div> : null}
            <div className={styles.productNameContainer}>
                <div className={styles.productName}>
                    {product?.productName}
                </div>
                <div className={styles.productDetails}>
                    {product?.variant ? <div className={styles.productDetailsText}>
                        {product?.variant}
                    </div> : null}
                    {product?.sku && product?.variant ? <div className={styles.productDetailsSeparator}></div> : null}
                    <div className={styles.productDetailsText}>
                        {product?.sku}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default SelectedProductsDrawer;